import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { FacilityReportWebsiteData } from "../../../../models/FacilityReportData";
import { LineChart } from "../../../AnalysisCollectionsComponents/CollectionChartArea/LineChart";

interface IWebsiteSectionProps {
  website?: FacilityReportWebsiteData;
  isDownloading: boolean;
}

export const WebsiteSection: React.FunctionComponent<IWebsiteSectionProps> = (
  props
) => {
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`facilityReportsPage.facilityReportDetails.websiteSection.${key}`);
  const { website, isDownloading } = props;

  const [timeUnit, setTimeUnit] = useState<"day" | "week" | "month">(
    website?.time_unit ?? "day"
  );

  if (!website) {
    return null;
  }

  return (
    <div className="website-section white-border-panel facility-report-details-section">
      <div
        className="inner-container"
        id="facility-report-details-website-section"
      >
        <h2>{t("title")}</h2>
        {website.ai_summary && (
          <p className="ai-summary">{website.ai_summary}</p>
        )}
        <LineChart
          chartDetailsData={website.website_clicks_data}
          usePrevYear={false}
          timeUnit={timeUnit}
          skipLabelTranslation={false}
          setTimeUnit={setTimeUnit}
          showTimeUnitSelect={!isDownloading}
        />
      </div>
    </div>
  );
};
